import { CONFIG } from "@/config";

export interface ReturnTarget {
  url: string;
  label: string;
}

const PRODUCTS_PAGE: ReturnTarget = { url: "/", label: "products" };

const KNOWN_PRODUCTS: { product: string; url: string; label: string }[] = [
  { product: "BOOST", url: CONFIG.TALENT_BOOST_URL, label: "SkillPanel" },
  { product: "SCORE", url: CONFIG.TALENT_SCORE_URL, label: "SkillCheck" },
];

/**
 * Where the account screens send someone who is done. A referrer wins because it is the only
 * evidence of where this visit actually started; `MainView`'s stored redirect is deliberately not
 * consulted, since it expires after a minute and enrollment takes longer than that.
 */
export const resolveReturnTarget = (referrer: string, products: string[]): ReturnTarget => {
  const fromReferrer = KNOWN_PRODUCTS.find((candidate) => {
    if (!candidate.url || !referrer) {
      return false;
    }
    try {
      return new URL(referrer).origin === new URL(candidate.url).origin;
    } catch {
      return false;
    }
  });
  if (fromReferrer) {
    return { url: fromReferrer.url, label: fromReferrer.label };
  }

  const owned = KNOWN_PRODUCTS.filter((candidate) => products.includes(candidate.product));
  if (owned.length === 1) {
    return { url: owned[0].url, label: owned[0].label };
  }

  return PRODUCTS_PAGE;
};
